import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35516db6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=35516db6&prod&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=35516db6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35516db6",
  null
  
)

export default component.exports